import ContentBody from '@op/components/ContentBody';
import { CONTACT_NAME, CONTACT_EMAIL } from '@op/constants';
import React, { useMemo } from 'react';
import { Layout, Tabs } from 'tea-component';
import { connect, getLocale, useIntl } from 'umi';
import './index.scss';
import { useFilterCondConf } from '@op/hooks/useFilterCondConf';
import useTabHistory from '@op/hooks/useTabHistory';
import MonitorMethod from './pages/MonitorMethod';
import TopicDefinition from './pages/TopicDefinition';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { monitorScopeMonitor, monitorScopeTopic } from '@op/operationLog/pages';
const { Content } = Layout;

function MonitoringScope({ gameInfo }: any) {
  const { formatMessage } = useIntl();
  const lang = getLocale();

  const { onActive, tab: activeId } = useTabHistory({
    defaultValue: 'Monitor',
  });

  useInitBuriedPointInfo({
    buriedPoint:
      activeId === 'Monitor' ? monitorScopeMonitor : monitorScopeTopic,
  });

  const {
    topic_trans,
    monitor_by_account_category,
    monitor_by_keyword,
    keyword_mutual_account_config,
  } = useFilterCondConf({
    gameInfo,
    requestList: [
      { key: 'topic_trans', defaultValue: [] },
      { key: 'key_topic', defaultValue: {} },
      { key: 'monitor_by_account_category', defaultValue: [] },
      { key: 'monitor_by_keyword', defaultValue: [] },
      { key: 'keyword_mutual_account_config', defaultValue: false },
    ],
    needRender: true,
  });

  const filterOptions = useMemo(() => {
    return {
      topic_trans,
      monitor_by_account_category,
      monitor_by_keyword,
      keyword_mutual_account_config,
    };
  }, [topic_trans, monitor_by_account_category, keyword_mutual_account_config]);

  return (
    <Content className="dbo-page dbo-monitoring-scope">
      <ContentBody
        contentHeard={
          <Content.Header
            className="dbo-header contentHead-normal"
            title={formatMessage({ id: 'Guidelines' })}
          >
            <div className="header-tab">
              <Tabs
                ceiling
                tabs={[
                  {
                    id: 'Monitor',
                    label: formatMessage({ id: 'Monitor Method' }),
                  },
                  {
                    id: 'Topic',
                    label: formatMessage({ id: 'Topic Definition' }),
                  },
                ]}
                animated={false}
                activeId={activeId}
                onActive={onActive}
              />
            </div>
            <div className="dbo-header-tips">
              {formatMessage({
                id: 'Please contact @{contact}({email}) for configuration',
              }, { contact: CONTACT_NAME, email: CONTACT_EMAIL })}
            </div>
          </Content.Header>
        }
      >
        {activeId === 'Monitor' ? (
          <MonitorMethod
            lang={lang}
            filterOptions={filterOptions}
          ></MonitorMethod>
        ) : (
          <TopicDefinition
            lang={lang}
            filterOptions={filterOptions}
          ></TopicDefinition>
        )}
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(MonitoringScope);
